export const CASINO_MULTIVIEW_ENABLED_QUERY_VALUE = 'enabled';
export const CASINO_MULTIVIEW = 'multiview';
